import React from "react";
import { Tag, Tooltip } from "antd";

import {
  StudioClipQcGate,
  type StudioClipQcResult,
} from "@fitness-app/data-models/entities/StudioClip";

const GATE_LABELS: Record<StudioClipQcGate, string> = {
  [StudioClipQcGate.Frame]: "Kadr",
  [StudioClipQcGate.Audio]: "Audio",
  [StudioClipQcGate.Subtitles]: "Napisy",
  [StudioClipQcGate.Cut]: "Cięcie",
  [StudioClipQcGate.Hook]: "Hook",
  [StudioClipQcGate.Length]: "Długość",
};

const BLOCKING = new Set([
  StudioClipQcGate.Frame,
  StudioClipQcGate.Audio,
  StudioClipQcGate.Subtitles,
  StudioClipQcGate.Cut,
]);

const formatTimestamp = (timestampMs?: number | null) => {
  if (timestampMs == null) return "";
  const totalSeconds = Math.floor(timestampMs / 1000);
  return ` (${Math.floor(totalSeconds / 60)}:${String(totalSeconds % 60).padStart(2, "0")})`;
};

/**
 * Wynik sześciu bramek QC (TRE-1981) przy klipie. Bramki blokujące świecą na czerwono,
 * hook/długość tylko ostrzegają. Brak werdyktu (awaria QC w tasku) jest jawnie nazwany —
 * człowiek ma wiedzieć, że akceptuje bez kontroli maszynowej.
 */
export const ClipQcTags = ({ qc }: { qc: StudioClipQcResult | null }): React.ReactElement => {
  if (!qc?.gates) {
    return <Tag color="default">Brak wyniku QC</Tag>;
  }

  const gates = qc.gates;

  return (
    <div className="flex flex-wrap gap-1">
      {Object.values(StudioClipQcGate).map((gate) => {
        const result = gates?.[gate];
        if (!result) return null;
        const failedBlocking = !result.pass && BLOCKING.has(gate);

        return (
          <Tooltip key={gate} title={`${result.reasoning}${formatTimestamp(result.timestampMs)}`}>
            <Tag color={result.pass ? "success" : failedBlocking ? "error" : "warning"} className="!mr-0">
              {GATE_LABELS[gate]}
            </Tag>
          </Tooltip>
        );
      })}
    </div>
  );
};
